/*
  <double-range-slider> custom element — native replacement for kubix.js DoubleRangeSlider.

  Used by snippets/facets.liquid for price range filters. Expects this DOM:
    <double-range-slider theme="#color">
      <input class="from-slider" type="range" min max value>
      <input class="to-slider"   type="range" min max value>
      <input class="from-input"  type="number" min max value name>
      <input class="to-input"    type="number" min max value name>
    </double-range-slider>

  Bidirectionally syncs the two range sliders with their number-input pairs,
  prevents `from` from exceeding `to`, and paints the active range as a
  coloured gradient on the to-slider's background.
*/
if (!customElements.get("double-range-slider")) {
  customElements.define(
    "double-range-slider",
    class DoubleRangeSlider extends HTMLElement {
      connectedCallback() {
        const fromSlider = this.querySelector(".from-slider");
        const toSlider = this.querySelector(".to-slider");
        const fromInput = this.querySelector(".from-input");
        const toInput = this.querySelector(".to-input");
        if (!fromSlider || !toSlider || !fromInput || !toInput) return;

        const theme = this.getAttribute("theme") || "#000";
        const trackColor = "#C6C6C6";

        const fillSlider = () => {
          const min = Number(toSlider.min);
          const max = Number(toSlider.max);
          const range = max - min || 1;
          const fromPct = ((Number(fromSlider.value) - min) / range) * 100;
          const toPct = ((Number(toSlider.value) - min) / range) * 100;
          toSlider.style.background = `linear-gradient(to right,
            ${trackColor} 0%,
            ${trackColor} ${fromPct}%,
            ${theme} ${fromPct}%,
            ${theme} ${toPct}%,
            ${trackColor} ${toPct}%,
            ${trackColor} 100%)`;
        };

        // When the upper slider is at its minimum it sits beneath the lower
        // slider, so lift it above so the user can still grab it.
        const setToggleAccessible = () => {
          toSlider.style.zIndex =
            Number(toSlider.value) <= Number(toSlider.min) ? 2 : 0;
        };

        // Drag the upper end of the lower slider down to match the to-value.
        fromSlider.addEventListener("input", () => {
          const from = Number(fromSlider.value);
          const to = Number(toSlider.value);
          if (from > to) {
            fromSlider.value = to;
            fromInput.value = to;
          } else {
            fromInput.value = from;
          }
          fillSlider();
        });

        toSlider.addEventListener("input", () => {
          const from = Number(fromSlider.value);
          const to = Number(toSlider.value);
          if (to < from) {
            toSlider.value = from;
            toInput.value = from;
          } else {
            toInput.value = to;
          }
          fillSlider();
          setToggleAccessible();
        });

        fromInput.addEventListener("input", () => {
          const from = Number(fromInput.value);
          const to = Number(toInput.value);
          if (from > to) {
            fromSlider.value = to;
            fromInput.value = to;
          } else {
            fromSlider.value = from;
          }
          fillSlider();
        });

        toInput.addEventListener("input", () => {
          const from = Number(fromInput.value);
          const to = Number(toInput.value);
          if (to < from) {
            toSlider.value = from;
            toInput.value = from;
          } else {
            toSlider.value = to;
          }
          fillSlider();
          setToggleAccessible();
        });

        fillSlider();
        setToggleAccessible();
      }
    }
  );
}
